import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ConfirmApplyTemplateModal = ({ isActive, onCancel, onConfirm }) => (
  <Modal
    buttons={[
      <Button key="cancel-apply-template" onClick={onCancel} text="Cancel" variant="secondary" />,
      <Button
        key="confirm-apply-template"
        onClick={onConfirm}
        text="Apply Template"
        variant="primary"
      />,
    ]}
    isActive={isActive}
    onClose={onCancel}
    size="small"
    title="Apply Template?"
  >
    <p>Applying this template will replace the cards currently on your canvas.</p>
  </Modal>
);

ConfirmApplyTemplateModal.propTypes = {
  isActive: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmApplyTemplateModal;
